up.compiler('#notes', function() {
  function checkPaneView() {
    const $body = $(document.body)
    const paneView = !!up.fragment.get('.pane_view')
    $body.toggleClass('without_tail', paneView)
  }

  checkPaneView()
  return checkPaneView
})
